<template>
  <div class="flex flex-row items-center gap-2 rounded-md bg-neutral-100 p-1">
    <button
      v-for="option in options"
      :key="String(option.value)"
      type="button"
      class="flex-1 rounded-md px-4 py-2 text-sm font-medium transition-all"
      :class="
        modelValue === option.value ? 'bg-white text-primary-500 shadow-sm' : 'text-neutral-500 hover:text-neutral-700'
      "
      @click="emit('update:modelValue', option.value)"
    >
      {{ typeof option.label === 'function' ? option.label() : t(option.label) }}
    </button>
  </div>
</template>

<script setup lang="ts">
import { useI18n } from 'vue-i18n';

interface SegmentedOption {
  value: string | boolean;
  label: string | (() => string);
}

interface Props {
  modelValue: string | boolean;
  options: SegmentedOption[];
}

withDefaults(defineProps<Props>(), {});

const emit = defineEmits<{
  (e: 'update:modelValue', value: string | boolean): void;
}>();

const { t } = useI18n();
</script>
